export default __webpack_public_path__ + "static/reset-dfac69dff556e5959f986d7eb2919ff9.png";